import { useState } from "react";

import { MultiTypeDownloadToolTip, Table, TablePaginationProps, TableProps, Typography } from "@king-ict/eupisi-ui/components";
import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export interface ListTableProps {
  tableProps: TableProps,
  showDownload?: boolean,
  onClickDownload?: any;
  pageSizeOptions?: number[];
}

export const ListTable = ({
  tableProps,
  showDownload = false,
  onClickDownload,
  pageSizeOptions
}: ListTableProps) => {
  const { t } = useTranslation();
  const [exportType, setExportType] = useState<ExportTypeEnum>(ExportTypeEnum.Excel)

  /// ------ EVENTS
  const handleChangeFormat = (typeId: number) => {
    setExportType(typeId)
  };
  const handleClickDownload = () => {
    onClickDownload(exportType);
  };

  const tablePaginationProps = () => {
    return {
      ...tableProps.paginationProps,
      pageSizeOptions: pageSizeOptions
    } as TablePaginationProps
  }

  return (

    <div className="border p-3 pb-0 mb-0">
      {(tableProps?.data && tableProps?.data.length > 0)
        ? (
          <>
            {!pageSizeOptions &&
              (<Table {...tableProps} />)
            }
            {!!pageSizeOptions &&
              <Table
                {...tableProps}
                paginationLocation="both"
                paginationProps={tablePaginationProps()} />
            }
            {showDownload &&
              (
                <Row className="pb-0 mb-0">
                  <Col md={3} className="pb-0 mb-0">
                    <MultiTypeDownloadToolTip
                      withOverlay={true}
                      exportType={exportType}
                      onclick={handleClickDownload}
                      changeFormat={handleChangeFormat}
                    ></MultiTypeDownloadToolTip>
                  </Col>
                </Row>
              )
            }
          </>
        ) : (
          <Row className="bg-light m-1">
            <Col md={12} className="text-center mt-2">
              <Typography variant="XLargeBold" component="h2">
                {t("common.noData")}
              </Typography>
            </Col>
          </Row>
        )
      }
    </div>
  );
};

